import styled from 'styled-components';
import mainColors from '../../../../Style-guide/main-colors';

const OrganizerLogin = styled.main`
  background: ${mainColors.main_color_gradient};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 0 20px;

  .organizer-login-container {
    background-color: ${mainColors.dark_background};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    width: 100%;
    padding: 48px;
    border-radius: 12px;
  }

  .organizer-login-input {
    max-width: 280px;
    width: 100%;
    margin-bottom: 20px;

    .error-message {
      margin: 4px;
    }
  }

  .organizer-login-button {
    padding: 8px 20px;
  }
`;

export default OrganizerLogin;
